import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { render } from 'preact';
import { useCallback, useEffect, useState } from 'preact/hooks';
import isEmail from 'validator/es/lib/isEmail';
import { getSession, getShotPaySession, Tokens } from '../../api/Client';
import { Members } from '../../api/Client';
const SWAPayTokenModal = () => {
    const [canSubmit, setCanSubmit] = useState(false);
    const [email, setEmail] = useState("");
    const handleInputEmail = (evt) => {
        setEmail(evt.currentTarget.value);
    };
    const [errors, setErrors] = useState(new Map());
    const [modalOpended,] = useState(true);
    const [storeId, setStoreId] = useState(0);
    const [memberCode, setMemberCode] = useState('');
    useEffect(() => {
        getSession().then(({ data }) => {
            if (data.storeId) {
                setStoreId(data.storeId);
            }
            if (data.paymentForm) {
                setMemberCode(data.paymentForm.cardTokens[0]);
            }
            const { ordererForm } = data;
            if (ordererForm.orderer) {
                const { email } = ordererForm.orderer;
                setEmail(email ?? '');
            }
        });
        getShotPaySession().then(({ data }) => {
            if (data.storeId) {
                setStoreId(data.storeId);
            }
            if (data.paymentForm) {
                setMemberCode(data.paymentForm.cardTokens[0]);
            }
            if (data.orderer) {
                const { email } = data.orderer;
                setEmail(email ?? '');
            }
        });
        const hiddenStoreId = document.querySelector('input[name="storeId"]');
        if (hiddenStoreId && hiddenStoreId.value) {
            setStoreId(Number(hiddenStoreId.value));
        }
    }, []);
    useEffect(() => {
        // メアド検証
        const emailErrors = [];
        if (isEmail(email, {}) === false && email.length > 0) {
            emailErrors.push('正しいメールアドレスを入力してください');
        }
        // TEL検証
        const phoneErrors = [];
        // メアドかTELの入力状態チェック
        if (email.length === 0) {
            phoneErrors.push('メールアドレスの入力が必要です');
        }
        // disable制御
        setCanSubmit(emailErrors.length === 0 && phoneErrors.length === 0);
        const validationErrors = new Map();
        if (emailErrors.length > 0) {
            validationErrors.set('email', emailErrors);
        }
        if (phoneErrors.length > 0) {
            validationErrors.set('phone', phoneErrors);
        }
        setErrors(validationErrors);
    }, [email]);
    const [verified, setVerified] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const handleClickVerify = useCallback(async () => {
        const { data } = await Members.getSwapayMember(storeId, '', email);
        if (data.registered) {
            setVerified(true);
            const { confirmed, phone_confirmed_at } = (await Members.retrieveSwapayUser(storeId, data.identifierCode)).data;
            // 認証済みでないなら再通知
            if (!confirmed && !phone_confirmed_at) {
                await Members.resendVerification(storeId, data.identifierCode);
            }
        }
        else {
            // 未登録であれば登録して先に進む
            const memberCode = "swapay_" + Tokens.generateMemberCode().slice(0, -7);
            await Members.saveSwapayMember(storeId, memberCode, '', email);
            setVerified(true);
        }
    }, [email, storeId, memberCode]);
    const handleSubmit = useCallback(() => {
        setSubmitting(true);
        document.forms[0].submit();
    }, []);
    return (_jsxs("div", Object.assign({ className: `modal is-clipped ${modalOpended ? 'is-active' : ''}` }, { children: [_jsx("div", { class: "modal-background" }, void 0),
            _jsxs("section", Object.assign({ class: "modal-card" }, { children: [_jsx("header", Object.assign({ class: "modal-card-head header" }, { children: _jsx("p", Object.assign({ class: "modal-card-title" }, { children: "\u6C7A\u6E08\u5B9F\u884C" }), void 0) }), void 0),
                    _jsxs("section", Object.assign({ class: "modal-card-body body" }, { children: [_jsx("h6", { children: "\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u306E\u4E0A\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3001\u3082\u3057\u304F\u306FSMS\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u53D7\u4FE1\u53EF\u80FD\u306A\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002" }, void 0),
                            _jsx("div", Object.assign({ className: 'my4 form-container' }, { children: _jsxs("div", Object.assign({ className: 'field' }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9" }), void 0),
                                        _jsx("div", Object.assign({ className: 'control' }, { children: _jsx("input", { className: `input ${errors.has('email') ? 'is-danger' : ''}`, type: "email", placeholder: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", value: email, onInput: handleInputEmail }, void 0) }), void 0),
                                        errors.has('email') && (_jsx("small", Object.assign({ class: "help is-danger" }, { children: errors.get('email')?.join('') }), void 0))] }), void 0) }), void 0)] }), void 0),
                    _jsx("footer", Object.assign({ class: "modal-card-foot is-justify-content-space-between" }, { children: _jsxs("div", Object.assign({ className: 'flex flex__column w100' }, { children: [_jsx("button", Object.assign({ type: "button", class: "button button__danger button__md button__block mb1", disabled: !canSubmit || verified, onClick: handleClickVerify }, { children: "\u30A2\u30C9\u30EC\u30B9\u78BA\u8A8D" }), void 0),
                                _jsxs("div", Object.assign({ className: 'flex flex__row flex__justify-content-center w100 my3' }, { children: [_jsx("i", { className: 'fas fa-arrow-down mx2' }, void 0),
                                        _jsx("i", { className: 'fas fa-arrow-down mx2' }, void 0),
                                        _jsx("i", { className: 'fas fa-arrow-down mx2' }, void 0),
                                        _jsx("i", { className: 'fas fa-arrow-down mx2' }, void 0),
                                        _jsx("i", { className: 'fas fa-arrow-down mx2' }, void 0)] }), void 0),
                                _jsx("button", Object.assign({ type: "button", class: "button button__danger button__md button__block mb1", disabled: !verified || submitting, onClick: handleSubmit }, { children: "\u6C7A\u6E08\uFF083DS\u8A8D\u8A3C\uFF09\u3078\u9032\u3080" }), void 0),
                                _jsx("small", Object.assign({ className: 'is-size-7 is-text-danger w100 has-text-centered' }, { children: "\u5225\u753B\u9762\u30673DS\u8A8D\u8A3C\u304C\u958B\u304D\u307E\u3059\u3002" }), void 0)] }), void 0) }), void 0)] }), void 0)] }), void 0));
};
window.addEventListener('load', () => {
    const root = document.getElementById('SWAPayTokenModal');
    if (root) {
        render(_jsx(SWAPayTokenModal, {}, void 0), root);
    }
});
